import * as React from 'react';
import ReactDOM from 'react-dom';
import Datatable from "../../DataTable";
import { roleTableColumns, roleTableOptions } from "./config"
import { UserInfo } from "../../Login/common/defaults"

interface IUserListUIProps {
    Roles:UserInfo[];
    selectRoleToEdit:(id:number) => void;
}

export default class UserListUI extends React.Component<IUserListUIProps,any> {
    render() {

        const roleTablecolumnDefs = [
            {
              targets: 0,
              orderable:false,
              createdCell: (td, cellData, rowData, row, col) => {
                return ReactDOM.render(
                  <i className="fas fa-edit pointer" data-id={cellData} onClick={() => {this.props.selectRoleToEdit(cellData)}}></i>,
                  td
                );
              }
            }
        ];

        return (
            <Datatable id="tblUserAdministration" columns={roleTableColumns} {...roleTableOptions} data={this.props.Roles} columnDefs={roleTablecolumnDefs} />
        )
    }
}